import type React from 'react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { AppButton, Modal } from '@/components/framework'

interface ValidationReminderModalProps {
  isOpen: boolean
  onCancel: () => void
  onContinue: () => void
}

export const ValidationReminderModal: React.FC<ValidationReminderModalProps> = ({
  isOpen,
  onCancel,
  onContinue,
}) => {
  const { t } = useTranslation()
  const [acknowledged, setAcknowledged] = useState(false)

  const handleClose = () => {
    setAcknowledged(false)
    onCancel()
  }

  const handleContinue = () => {
    if (!acknowledged) return
    setAcknowledged(false)
    onContinue()
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title={t('dashboard.assignment.validationReminder.title')}
      size="md"
    >
      <div className="space-y-6">
        <p className="text-sm text-gray-700">{t('dashboard.assignment.validationReminder.body')}</p>

        <label className="flex items-start gap-2 text-sm text-gray-900">
          <input
            type="checkbox"
            checked={acknowledged}
            onChange={(e) => setAcknowledged(e.target.checked)}
            className="mt-0.5 size-4 rounded border border-gray-300"
          />
          <span>{t('dashboard.assignment.validationReminder.checkboxLabel')}</span>
        </label>

        <div className="mt-4 flex justify-end gap-gap-sm border-t border-border-lighter pt-4">
          <AppButton variant="secondary" size="md" onClick={handleClose}>
            {t('dashboard.assignment.validationReminder.cancel')}
          </AppButton>
          <AppButton variant="primary" size="md" onClick={handleContinue} disabled={!acknowledged}>
            {t('dashboard.assignment.validationReminder.continue')}
          </AppButton>
        </div>
      </div>
    </Modal>
  )
}
